import { IntegrationConfig } from 'modules/Integrations/domain'
import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import xeroLogo from './xeroLogo.svg'
import { xeroConfigurationLoader } from 'modules/Integrations/integrationsConfig/xero/xero.loader'
import { xeroConfigurationMutator } from 'modules/Integrations/integrationsConfig/xero/xero.mutator'
import { XeroConfigurationManagement } from './XeroConfigurationManagement/XeroConfigurationManagement'
import { XeroIntegrationDetail } from './XeroIntegrationDetail/XeroIntegrationDetail'
import { XeroIntegrationManagementInspector } from './XeroIntegrationManagementInspector/XeroIntegrationManagementInspector'
import type { PaymentBankAccountsByCurrency } from 'Integrations/integrationsConfig/common/PaymentBankAccounts/paymentBankAccounts.types'

export const xeroIntegrationConfig: IntegrationConfig = {
  logoUrl: xeroLogo,
  smallLogoUrl: xeroLogo,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors/xero',
  title: 'Xero',
  description:
    'Sync Sequence invoices in real-time and streamline your accounting process.',
  features: {
    canDeleteLinks: true,
    canUninstall: true,
    isDocumentationOnly: false
  },
  components: {
    detail: XeroIntegrationDetail,
    management: XeroConfigurationManagement,
    inspector: XeroIntegrationManagementInspector
  },
  communication: {
    configuration: {
      loader: xeroConfigurationLoader,
      mutator: xeroConfigurationMutator
    }
  }
}

export type XeroIntegrationConfig = {
  defaultLedgerAccount: string
  defaultCreditLedgerAccount: string
  defaultMinimumLedgerAccount: string
  defaultTaxLiabilityLedgerAccount: string
  untaxedCustomerTaxCode: string
  /**
   * This is a value which does not exist on the API; it's effectively how we control
   * if an integration is 'paused' or not for now. It's expected that a way to more
   * directly configure this value will be exposed at some point!
   */
  importCustomerWorkflow: boolean
  /** Push unlinked customers to Xero when an invoice is finalised or sent. */
  autoLinkCustomers: boolean
  paymentBankAccounts: PaymentBankAccountsByCurrency
  /** Loaded selections used to submit only changed currency mappings. */
  initialPaymentBankAccounts?: PaymentBankAccountsByCurrency
  /** Resolved sync permission for the auto-link toggle (read-only, for the paused state). */
  autoLinkSyncPermission?: Dashboardv99990101Api.GetEntityTypeSyncToggles.SyncPermission
}
